<!-- 快捷选择请假事由 -->
<template>
  <van-popup v-model:show="showPicker" position="bottom">
    <van-space direction="vertical" fill>
      <div
        style="
          width: 100;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #ebedf0;
        "
      >
        <span style="font-size: 14px; margin-left: 10px">请假事由快捷语</span>
        <van-icon
          name="cross"
          style="padding: 15px"
          @click="showPicker = false"
        />
      </div>
      <van-list>
        <van-cell
          v-for="(item, index) in remarkArr"
          :key="item"
          :title="item"
          @click="handleSelect(index, item)"
        >
          <template #right-icon>
            <van-icon
              v-if="selectIndex === index"
              name="success"
              color="#1989fa"
            />
          </template>
        </van-cell>
      </van-list>
    </van-space>
  </van-popup>
</template>

<script setup lang="ts">
const props = defineProps({
  leaveType: { type: Number, default: 1 },
});
const emits = defineEmits(["onSelect"]);

const showPicker = ref(false);
const selectIndex = ref(-1);
const type1 = [
  "车库开车",
  "不动产中心办理抵押登记",
  "盘点",
  "到工商税务及公安法院部门办事",
  "到车站机场酒店接送客人",
  "实地评估抵押物",
  "车辆过户",
  "接待客人",
];
const type2 = ["吃饭"];
const remarkArr: any = computed(() => {
  console.log("type", props.leaveType);
  if (props.leaveType == 1) {
    // 公事
    return type1;
  }
  // 私事
  return type2;
});
onMounted(() => {
  console.log("===onmounted===");
});
const show = () => {
  showPicker.value = true;
};

const handleSelect = (index, item) => {
  selectIndex.value = index;
  emits("onSelect", item);
  showPicker.value = false;
};

defineExpose({
  show,
});
</script>
